import { memo } from "react";

import { ProgressBar } from "@components/ProgressBar";
import { Text } from "@components/Text";
import { type ThemeMode } from "@root/tablescape/state";
import { tw } from "classnames";

const styles = {
  container: tw("w-full", "flex", "flex-row", "items-center", "py-1"),
  bar: tw("flex-1"),
  prefixText: tw("text-primary", "w-4", "mr-4"),
  suffixText: tw(
    "pl-4",
    "md:pl-6",
    "w-1/3",
    "whitespace-nowrap",
    "text-primary"
  ),
};

type Props = {
  percentage: number;
  prefixText: string;
  suffixText: string;
  theme: ThemeMode;
};

const ReviewRatingBarBase = ({
  percentage,
  prefixText,
  suffixText,
  theme,
}: Props) => {
  return (
    <div className={styles.container}>
      <Text as="body1" className={styles.prefixText} size="lg">
        {prefixText}
      </Text>
      <ProgressBar
        className={styles.bar}
        progressPercentage={percentage}
        theme={theme}
        type="review"
      />
      <Text className={styles.suffixText}>{suffixText}</Text>
    </div>
  );
};

export const ReviewRatingBar = memo(ReviewRatingBarBase);
